export default __webpack_public_path__ + "static/media/nav_img_16.2ddd01db.jpg";